export const features = [
  {
    id: "1",
    logo: "/press/logos/time.svg",
    source: "TIME MAGAZINE",
    read: "1 min read",
    caption:
      "Time Magazine Names Reeddi’s Grid-Free Electricity Best Invention of the Year, 2021.",
    link: "https://time.com/collection/best-inventions-2021/6113115/reeddi",
    image: "/press/womanHandReddiCapsule.png",
  },
  {
    id: "2",
    logo: "/press/logos/StartUp.svg",
    source: "STARTUP HERE TORONTO",
    read: "3 mins read",
    caption:
      "How Reeddi went from dorm room dream to Time magazine’s best inventions list",
    link: "https://startupheretoronto.com/type/startup-news/how-reeddi-went-from-dorm-room-dream-to-time-magazines-best-inventions-list/",
    image: "/press/womanChargerReeddiCapsule.png",
  },
  {
    id: "3",
    logo: "/press/logos/fastCompany.svg",
    source: "FAST COMPANY",
    read: "1 min read",
    caption:
      "This Nigerian startup sells solar-powered batteries at corner stores",
    link: "https://www.fastcompany.com/90679524/this-nigerian-startup-sells-solar-powered-batteries-at-corner-stores",
    image: "/press/fastcompany.png",
  },
  {
    id: "4",
    logo: "/press/logos/VA logo.svg",
    source: "VENTURES AFRICA",
    read: "3 mins read",
    caption:
      "Reeddi Capsule is Helping Nigerian Businesses Gain Access To Clean Energy on the Go",
    link: "https://venturesafrica.com/olugbenga-olubanjos-reeddi-capsule-is-helping-nigerian-businesses-gain-access-to-clean-energy-on-the-go/",
    image: "/press/ventureAfrica.jpg",
  },
  {
    id: "5",
    logo: "/press/logos/thirdDerivative.svg",
    source: "THIRD DERIVATIVE",
    read: "2 mins read",
    caption: "Ecosystem Spotlight: Reeddi’s Clean Energy-as-a-Service Solution",
    link: "https://www.third-derivative.org/blog/ecosystem-spotlight-reeddis-clean-energy-as-a-service-solution?hsLang=en",
    image: "/press/peopleWithReeddiCapsule.png",
  },
  {
    id: "6",
    logo: "/press/logos/uoft.svg",
    source: "U of T NEWS",
    read: "3 mins read",
    caption:
      "U of T alumnus Olugbenga Olubanjo one of 15 finalists for $1.7-million Earthshot Prize",
    link: "https://www.utoronto.ca/news/u-t-alumnus-olugbenga-olubanjo-one-15-finalists-17-million-earthshot-prize",
    image: "/press/uOfT.png",
  },
  {
    id: "7",
    logo: "/press/logos/blueGreen.svg",
    source: "BLUE & GREEN",
    read: "2 mins read",
    caption:
      "Nigerian Startup Sells Solar-Powered Rechargeable Batteries Locally",
    link: "https://blueandgreentomorrow.com/news/nigerian-startup-sells-solar-powered-rechargeable-batteries-locally/",
    image: "/press/blueGreen.png",
  },
  {
    id: "8",
    logo: "/press/logos/The guardian.svg",
    source: "GUARDIAN",
    read: "1 min read",
    caption: "USADF, All On canvass improved power supply",
    link: "https://guardian.ng/business-services/usadf-all-on-canvass-improved-power-supply/",
    image: "/press/guardian2.jpeg",
  },
];

export const values = [
  {
    id: "1",
    image: "/about/accessibility.svg",
    title: "Innovation",
    content:
      "To Increase accessibility to quality and essential goods and services through locally tailored and sustainable innovation",
  },
  {
    id: "2",
    image: "/about/innovation.svg",
    title: "Venture Creation",
    content:
      "To create a venture where innovation is driven by customers, venture stakeholders, creative employers, and the society.",
  },
  {
    id: "3",
    image: "/about/tools.svg",
    title: "Tools and Machinery",
    content:
      "To seamlessly increase accessibility to equipment, appliances, tools and machinery.",
  },
  {
    id: "4",
    image: "/about/decarbon.svg",
    title: "Decarbonization",
    content:
      "To utilize data-driven, digitally-enabled systems to simplify customers' decarbonization journey.",
  },
  {
    id: "5",
    image: "/about/journey.svg",
    title: "Acessibility",
    content:
      "To utilize data-driven, digitally-enabled systems to simplify customers' accessibility journey.",
  },
  {
    id: "1",
    image: "/about/giving.svg",
    title: "Giving back",
    content:
      "To contribute greatly to the societal development by giving back more.",
  },
];
